// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2PCDK","colMaxWidth":"Table_colMaxWidth__1mzZL"};